import React, { useState } from "react";
import TourList from "../components/TourList";
import AddTourModal from "../components/AddTourModal";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";

const TourManagement = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [refreshList, setRefreshList] = useState(false);
    const [selectedTour, setSelectedTour] = useState(null);
    const universityId = localStorage.getItem("universityId");

    const navigate = useNavigate();

    const handleSaveTour = () => {
        console.log("Tour saved. Refreshing list...");
        setRefreshList((prev) => !prev); // Toggle refreshList to trigger re-fetch
        setSelectedTour(null); // Clear selected tour after save
        setShowAddModal(false); // Close modal after saving
    };

    const handleLogout = (event) => {
        event.preventDefault();
        console.log("Navigating to /login...");
        // Clear session storage
        localStorage.clear();
        navigate("/login");
    };

    const handleEditTour = (tour) => {
        setSelectedTour(tour); // Set the selected tour for editing
        setShowAddModal(true);
    };

    return (
        <div className="dashboard">
            <Sidebar/>

            <main className="main-content">
                <header className="header component">
                    <span className="component-header">Tours</span>
                    <button
                        className="btn btn-primary action btn-new-tour"
                        onClick={() => {
                            setSelectedTour(null); // Clear selected tour for new tour
                            setShowAddModal(true);
                        }}
                    >
                        <i className="fa fa-plus"></i> New Tour
                    </button>
                </header>
                <p><a href="/dashboard"> Home </a> &gt; Tours </p>
                <hr/>

                <TourList
                    universityId={universityId}
                    refreshKey={refreshList} // This triggers a re-fetch in the TourList component
                    onEdit={handleEditTour}
                />

                {showAddModal && (
                    <AddTourModal
                        universityId={universityId}
                        tour={selectedTour}
                        onClose={() => setShowAddModal(false)}
                        onSave={handleSaveTour} // Triggered when a tour is saved
                    />
                )}
            </main>
        </div>
    );
};

export default TourManagement;